import React, { useState, useEffect } from 'react'
import { SelectInline, InputInline, Field, PhoneInput } from '@arnsbogroup/react-voicearchive'

const AgencyInfo = ( {agency, onChange = () => {}} ) => {
  const currencyOptions = [
    { label: 'USD', value: 1 },
    { label: 'EUR', value: 2 },
    { label: 'DKK', value: 3 },
    { label: 'GBP', value: 4 },
    { label: 'NOK', value: 5 },
    { label: 'SEK', value: 6 },
    { label: 'ZAR', value: 58 },
  ]

  if (!agency) {
    return null
  }

  const [phoneValue, setPhoneValue] = useState(agency.phone)

  useEffect(() => {
    setPhoneValue(agency.phone)
  }, [agency?.phone])


  const onPhoneChange = (value, data, event, formattedValue) => {
    setPhoneValue(value);
  };

  const onPhoneBlur = (event) => {
    onChange({ ...agency, phone: phoneValue })
  };

  const onEmailChange = (value) => {
    if(confirm("Do you want to update all members email?")) {
      onChange({ ...agency, fullEmailUpdate: true, email: value })
    } else {
      onChange({ ...agency, email: value })
    }
  }

  return (
    <div className="p-4 text-center">
      <div className="grid grid-cols-1 gap-2 md:grid-cols-2 flex-initial w-full text-left order-3 md:order-none">
        <div className="space-y-4">
          <div>
            <InputInline
              labelClassName="text-xs"
              placeholder="Agency Name"
              label="Agency Name"
              value={ agency.name }
              onChange={({ target: { value } }) => {
                onChange({ ...agency, name: value })
              }}
            />
          </div>
          <div>
            <SelectInline
              labelClassName="text-xs"
              label="Agency Currency"
              placeholder="Currency"
              value={ currencyOptions.find(currency => agency.headSupplier.currencyObject.uid == currency.value) }
              options={ currencyOptions }
              onChange={(currency) => { onChange({
                ...agency, 
                headSupplier: {
                    ...agency.headSupplier,
                    currencyObject: {
                      ...agency.headSupplier.currencyObject,
                      uid: currency.value
                    }
                }
            }) }}
            />
          </div>
          <div>
            <InputInline
              labelClassName="text-xs"
              placeholder="Agency Email"
              label="Agency Email"
              value={ agency.email }
              onChange={({ target: { value } }) => {
                onEmailChange(value)
              }}
            />
          </div>
          <div className='w-72'>
            <PhoneInput
              label="Agency Phone"
              country='dk'
              enableSearch
              searchPlaceholder="Search"
              searchNotFound="Not found"
              value={phoneValue}
              onChange={onPhoneChange}
              onBlur={onPhoneBlur}
              placeholder="Agency phone"
            />
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <Field label="Head supplier ID" labelClassName="text-xs">
              { agency.headSupplier.userid }
            </Field>
          </div>
          <div>
            <Field label="Head supplier name" labelClassName="text-xs">
              { agency.headSupplier.firstname.concat(" ", agency.headSupplier.lastname) }
            </Field>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AgencyInfo
